<template>
  <div :class="bem.b()">
    <a-row :class="bem.m('table-header')" :gutter="20">
      <a-col :span="22">
        <a-row :gutter="20">
          <a-col
            v-for="(col, index) in props.columns"
            :key="index"
            :span="col.span"
            :class="bem.e('table-header-col')"
          >
            <span>{{ col.title }}</span>
            <ll-tooltip
              v-if="col.key === 'static'"
              tip="Content-Type 字段用于指定请求部分的媒体类型"
            />
          </a-col>
        </a-row>
      </a-col>

      <a-col :class="bem.e('table-header-col')" :span="2"> 操作 </a-col>
    </a-row>
    <div :class="bem.m('table-body')">
      <table-row
        v-for="(item, index) in props.dataSource"
        :key="index"
        :data="item"
        :columns="props.columns"
        :data-source="props.dataSource"
      />
      <a-row :gutter="20" :class="bem.e('table-row')">
        <a-col
          v-for="(col, index) in props.columns"
          :key="index"
          :span="col.span || 24 / props.columns.length"
          :class="bem.e('table-col')"
        >
          <template v-if="col.key === 'name'">
            <ll-input
              v-model:value="addData"
              placeholder="添加参数"
              :disabled="disabled"
              :bordered="false"
              @blur="handleAdd(props.dataSource)"
            />
          </template>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'

import { paramsTableProps } from '../config'

import { createNamespace } from '@ll-plus/utils'

import TableRow from './params-table-row.vue'

defineOptions({ name: 'LlParamsTable' })

const bem = createNamespace('params-table')

const props = defineProps(paramsTableProps)

const disabled = inject('disabled')

const addData = ref('')

const handleAdd = dataSource => {
  if (
    (addData.value && dataSource.find(e => e.name !== addData.value)) ||
    !dataSource.length
  ) {
    if (!addData.value) return
    dataSource.push({
      name: addData.value,
      required: false,
      value: '',
      static: false,
      description: '',
      contentType: ''
    })
    addData.value = ''
  }
}
</script>
